import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Text } from '@mantine/core';
import { Box, Button as MButton } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { jsPDF } from 'jspdf'; //or use your library of choice here
import autoTable from 'jspdf-autotable';
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux'
import { useMediaQuery } from '@mantine/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Table.css'
// import "./David-normal.js";

import {
    faAnglesDown,
    faBars,
    faBarsStaggered,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircleXmark,
    faColumns,
    faCompress,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faExpand,
    faEyeSlash,
    faFilter,
    faFilterCircleXmark,
    faFloppyDisk,
    faGrip,
    faLayerGroup,
    faSearch,
    faSearchMinus,
    faSort,
    faSortDown,
    faSortUp,
    faTextWidth,
    faThumbTack,
    faX,
  } from '@fortawesome/free-solid-svg-icons'; //replace free solid with your desired icon set
  import '@fortawesome/fontawesome-svg-core/styles.css';
  import { config } from '@fortawesome/fontawesome-svg-core';
  config.autoAddCss = true;

  const props = []
  const fontAwesomeIcons = {
    IconArrowAutofitContent: (props) => (
      <FontAwesomeIcon icon={faTextWidth} color="#325d88"  {...props} />
    ),
    IconArrowsSort: (props) => <FontAwesomeIcon icon={faSort} color="#325d88" {...props} />,
    IconBoxMultiple: (props) => (
      <FontAwesomeIcon icon={faLayerGroup} color="#325d88"  {...props} />
    ),
    IconChevronDown: (props) => (
      <FontAwesomeIcon icon={faChevronDown}  color="#325d88" {...props} />
    ),
    IconChevronLeft: (props) => (
      <FontAwesomeIcon icon={faChevronLeft}  color="#325d88" {...props} />
    ),
    IconChevronRight: (props) => (
      <FontAwesomeIcon icon={faChevronRight} color="#325d88" {...props} />
    ),
    IconChevronsDown: (props) => (
      <FontAwesomeIcon icon={faAnglesDown} color="#325d88" {...props} />
    ),
    IconCircleX: (props) => <FontAwesomeIcon icon={faCircleXmark}  color="#325d88" {...props} />,
    IconClearAll: (props) => (
      <FontAwesomeIcon icon={faBarsStaggered} color="#325d88" {...props} />
    ),
    IconColumns: (props) => <FontAwesomeIcon icon={faColumns} color="#325d88" {...props} />,
    IconDeviceFloppy: (props) => (
      <FontAwesomeIcon icon={faFloppyDisk} color="#325d88" {...props} />
    ),
    IconDots: (props) => <FontAwesomeIcon icon={faEllipsisH} color="#325d88" {...props} />,
    IconDotsVertical: (props) => (
      <FontAwesomeIcon icon={faEllipsisV} color="#325d88"{...props} />
    ),
    IconEdit: (props) => <FontAwesomeIcon icon={faEdit} color="#325d88" {...props} />,
    IconEyeOff: (props) => <FontAwesomeIcon icon={faEyeSlash}color="#325d88" {...props} />,
    IconFilter: (props) => <FontAwesomeIcon icon={faFilter} color="#325d88" {...props} />,
    IconFilterOff: (props) => (
      <FontAwesomeIcon icon={faFilterCircleXmark}color="#325d88" {...props} />
    ),
    IconGripHorizontal: (props) => <FontAwesomeIcon icon={faGrip} color="#325d88"{...props} />,
    IconMaximize: (props) => <FontAwesomeIcon icon={faExpand}color="#325d88" {...props} />,
    IconMinimize: (props) => <FontAwesomeIcon icon={faCompress} color="#325d88"{...props} />,
    IconPinned: (props) => <FontAwesomeIcon icon={faThumbTack} color="#325d88"{...props} />,
    IconPinnedOff: (props) => <FontAwesomeIcon icon={faThumbTack} color="#325d88"{...props} />,
    IconSearch: (props) => <FontAwesomeIcon icon={faSearch}color="#325d88" {...props} />,
    IconSearchOff: (props) => <FontAwesomeIcon icon={faSearchMinus} color="#325d88"{...props} />,
    IconSortAscending: (props) => <FontAwesomeIcon icon={faSortUp} color="#325d88"{...props} />,
    IconSortDescending: (props) => (
      <FontAwesomeIcon icon={faSortDown} color="#325d88"{...props} />
    ),
    IconBaselineDensityLarge: (props) => (
      <FontAwesomeIcon icon={faBars}color="#325d88" {...props} />
    ),
    IconBaselineDensityMedium: (props) => (
      <FontAwesomeIcon icon={faBars}color="#325d88" {...props} />
    ),
    IconBaselineDensitySmall: (props) => (
      <FontAwesomeIcon icon={faBars}color="#325d88" {...props} />
    ),
    IconX: (props) => <FontAwesomeIcon icon={faX} color="#325d88"{...props} />,
  };



const Table = () => {
    // const item = useSelector((state) => state.item.value)
    const draw = useSelector((state) => state.draw.value)
    const data = useSelector((state) => state.data.value)
    const item = useSelector((state) => state.item.value)
    const colSize = 2
    const [columnPinning, setColumnPinning] = useState({});
    const isDesktop = useMediaQuery('(min-width: 1200px)');

    const cellStyle = (rowIndex, colIndex) => {
      // Example: Change background color of the first cell in the first row
      if (rowIndex === 0 && colIndex === 0) {
        return {
          backgroundColor: 'red',
        };
      }
      // You can add more conditions and customize cell styles as needed.
      // Otherwise, return an empty object to keep the default style.
      return {backgroundColor: 'green',};
    };

    const handleExportRows = (rows) => {
        const doc = new jsPDF();
        doc.addFont("David-normal.ttf", "David", "normal");
        doc.setFont("David"); // set font
        doc.setFontSize(12);
        doc.setR2L(true);
        const tableData = rows.map((row) => Object.values(row.original).toReversed());
        const tableHeaders = columns.toReversed().map((c) => c.header);
        // console.log(doc.getFontList())

        autoTable(doc, {
            head: [tableHeaders],
            body: tableData,
            styles: { font: "David", halign: 'right', isSymmetricSwapping: true, isInputVisual: true, isOutputVisual: false }
        });

        doc.save('hotels.pdf')
    };

    const [columns, setColumns] = useState([

        //     {

        //     accessorKey: "מלון",
        //     header: "מלון",
        //     enableSorting: true,
        //     size: colSize,
        //     textAlign:"center",

        // },
        // {

        //     accessorKey: "תחנות תחבורה ציבורית בקרבת המלון",
        //     header: "תחנות תחבורה ציבורית בקרבת המלון",
        //     enableSorting: true,
        //     size: colSize,
        //     headerStyle: {textAlign: 'center'},
        // }, 
        {

            accessorKey: 'יעד',
            header: 'יעד',
            minSize: 2, //min size enforced during resizing
            maxSize: 10, //max size enforced during resizing
            enableSorting: true,
 
            size: colSize,
            textAlign: "right",
            mantineTableBodyCellProps: ({ cell, row }) => (row.depth === 0 ?{
              className: 'row-head',
              style: {backgroundColor:"#c6dbef", color:"#08519c", fontStyle:"italic"}
             
            }: {
              className: 'row-body',
             
            }),
           
      
            Cell: ({ cell, row, renderedCellValue }) => (
                row.depth === 0 ?
                    <Box style={{ fontWeight: "bold" , textAlign: "right",
                   
                   }}>
                        {renderedCellValue}
                    </Box> :
                    <Box style={{  textAlign: "right",}}>
                        {renderedCellValue}
                    </Box>
            ),
           

        }
        , {

            accessorKey: "דרכי הגעה בתחבורה ציבורית",
            header: "דרכי הגעה בתחבורה ציבורית",
            // key: uuid(),
            size: colSize,
            enableSorting: true,
            minSize: 2, //min size enforced during resizing
            maxSize: 10, //max size enforced during resizing
            // size: 100, //medium column,
            textAlign: "right",
            mantineTableBodyCellProps: ({ cell, row }) => (row.depth === 0 ?{
              className: 'row-head',
              style: {backgroundColor:"#c6dbef", color:"#08519c",fontStyle:"italic"}
             
            }: {
              className: 'row-body',
             
            }),
            Cell: ({ cell, row , renderedCellValue}) => (
              
                row.depth === 0 ?
                
                    <Box  style={{ fontWeight: "bold" , textAlign: "right", }}>
                      {renderedCellValue}
                    </Box> :
                    <Box style={{  textAlign: "right",}}>
                        {renderedCellValue}
                    </Box>
            ),
            // style: {  overflow:'wrap'}

        }])

    const [rows, setRows] = useState(
        {
            ["hotel"]: '',
            ["stops"]: '',
            ["יעד"]: '',
            ["דרכי הגעה בתחבורה ציבורית"]: ''

        }
    )

    const tableContainerRef = useRef(null); //we can get access to the underlying TableContainer element and react to its scroll events

    useEffect(() => {


        const output = []
        item.data.map((hotel) => {
            let id = 0
            const name = hotel.name
            const stops = hotel.stops
            const subRow = { "יעד": name, "דרכי הגעה בתחבורה ציבורית": `תחנות תחבורה ציבורית בקרבת המלון: ${stops}`, subRows: [], }

            Object.keys(hotel.destinations).map((dest) => {
                id += 1

                if (hotel.destinations[dest] != null | hotel.destinations[dest] == "") {
                    subRow.subRows.push({ ["יעד"]: dest, ["דרכי הגעה בתחבורה ציבורית"]: hotel.destinations[dest] })

                }
            })
            output.push(subRow)

        })

        setRows(output)





    }, [data, item])

    useEffect(() => {
      if (typeof window !== 'undefined') {
        if (isDesktop) {
          setColumnPinning({
            left: ['mrt-row-expand', 'mrt-row-numbers', 'cellInstanceAPI'],
            right: ['link'],
          });
        } else {
          setColumnPinning({});
        }
      }
    }, [isDesktop]);


    const table = useMantineReactTable({
        columns,
        data: rows,
        enableStickyHeader: true,
        captionSide: "top",
        enableExpanding: true,
        getSubRows: (originalRow) => originalRow.subRows,
        cellStyle:cellStyle,

        enableColumnOrdering: true,
       
        
        enableRowSelection: true,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        icons:fontAwesomeIcons,
        enableGrouping: true,
        initialState: {
            // density: 'xs',
            expanded: true,
            showGlobalFilter: true,
            // expanded: true,
            // grouping: ['מלון'],
            // // pagination: { pageIndex: 0, pageSize: 20 },
            // sorting: [{ id: 'hotel', desc: false }],
        },
       
        // renderDetailPanel: ({ row }) => (
        //   <Text color={row.original.description ? 'teal' : 'gray'}>
        //   {row.original.description || 'No Description Provided... Yet...'}
        // </Text>
        // ),
     
  

        mantinePaperProps: {
            shadow: 'none',
            sx: {
                borderRadius: '0',
                 marginBottom: '50px' ,
                border: '1px dashed #e0e0e0',
                tableLayout: 'fixed',
            },
        },
//         mantineTableProps:({table }) => (
//           // console.log(table)
//         //   row.depth==0? {
//         //     striped: true,
//         //     sx: {
//         //     'tbody > tr > td': {
           
//         //       backgroundColor: 'red'
//         //     },
//         //   }

//         // }:
//         // {
//         //   striped: true,
//         //   sx: {
//         //   'tbody > tr > td': {
         
//         //     backgroundColor: 'blue'
//         //   },
//         // }
// // 
//       // }
//       ),

        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <MButton
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)
                    onClick={() =>
                        handleExportRows(table.getPrePaginationRowModel().rows)
                    }
                    rightIcon={<IconDownload />}
                    variant="filled"
                >
                    הורד טבלה
                </MButton>
                {/* <MButton
                    disabled={table.getRowModel().rows.length === 0}
                    //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                    leftIcon={<IconDownload />}
                    variant="filled"
                >
                    שמור עמוד
                </MButton> */}
                <MButton
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    rightIcon={<IconDownload />}
                    variant="filled"
                >
                   הורד שורות בחורות
                </MButton>
            </Box>
        ),


    },);


    return (

        <div id="table">
            <MantineReactTable table={table} cellStyle={cellStyle}
            // onColumnPinningChange={setColumnPinning}
            // state={{ columnPinning }}
            



            />
        </div>

    )
};



export default Table;